export default "__VITE_ASSET__B9G6KHzI__"